import { 
  signInWithEmailAndPassword, 
  signOut,
  createUserWithEmailAndPassword
} from "firebase/auth";

import { auth } from "../firebase";

// LOGIN
export const loginUser = (email, password) =>
  signInWithEmailAndPassword(auth, email, password);

// REGISTER
export const registerUser = (email, password) =>
  createUserWithEmailAndPassword(auth, email, password);

// LOGOUT
export const logoutUser = async () => {
  await signOut(auth);
};